import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    id = parseInt(id, 10);

    let withdraw = state.get('withdraw') || Map();
    let user = withdraw.get(id) || Map();

    user = user
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0);

    return state.set(
        'withdraw', withdraw.set(id, user)
    );
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    let withdraw = state.get('withdraw') || Map();
    let user = withdraw.get(id) || Map();

    user = user
            .set('state', 'ERROR')
            .set('errors', fromJS(errors));

    return state.set(
        'withdraw', withdraw.set(id, user)
    );
}

export function form(state, { id, data }) {
    id = parseInt(id, 10);

    let withdraw = state.get('withdraw') || Map();
    let user = withdraw.get(id) || Map();

    user = user
            .set('state', 'FORM')
            .set('data', fromJS(data))
            .set('errors', void 0);

    return state.set(
        'withdraw', withdraw.set(id, user)
    );
}

export function finish(state, { id, transaction, customer }) {
    id = parseInt(id, 10);

    let withdrawEl = state.get('withdraw') || Map();
    let user = withdrawEl.get(id) || Map();

    user = user
            .set('state', 'FINISHED')
            .set('data', fromJS(transaction))
            .set('errors', void 0);

    state = state.set(
        'withdraw', withdrawEl.set(id, user)
    );

    if (!customer) {
        return state;
    }

    return state.setIn([ 'list', id, 'data' ], fromJS(customer));
}

export function clear(state, { id }) {
    id = parseInt(id, 10);

    return state.set(
        'withdraw',
        (state.get(id) || Map()).set(id, void 0)
    );
}
